<template>
  <div class="demo-container" :class="{ 'light-mode': isLightMode }">
    <!-- Navbar Sencilla -->
    <div class="demo-navbar">
      <div class="nav-brand">
        <i class="bi bi-palette"></i>
        <span>ColorTheme</span>
      </div>
      <div class="nav-links">
        <a href="#" class="nav-link">Diseño</a>
        <a href="#" class="nav-link">Colores</a>
        <a href="#" class="nav-link">UI</a>
      </div>
    </div>

    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-content">
        <h1>Sistema de Temas</h1>
        <p>Diseño adaptable que respeta tus preferencias visuales con paletas cuidadosamente seleccionadas</p>

        <!-- Toggle Interruptor Deslizante -->
        <div class="theme-toggle-section">
          <span class="toggle-label">Blue Mist Dark</span>
          <label class="switch">
            <input type="checkbox" v-model="isLightMode" @change="toggleTheme">
            <span class="slider">
              <i class="bi bi-moon-fill moon-icon"></i>
              <i class="bi bi-sun-fill sun-icon"></i>
            </span>
          </label>
          <span class="toggle-label">Blue Mist Light</span>
        </div>

        <!-- Botones de Acción -->
        <div class="hero-actions">
          <button class="btn btn-primary">
            <i class="bi bi-play-circle"></i>
            Iniciar Proyecto
          </button>
          <button class="btn btn-secondary">
            <i class="bi bi-collection"></i>
            Ver Portfolio
          </button>
        </div>
      </div>

      <!-- Elementos Decorativos MEJORADOS -->
      <div class="hero-elements">
        <div class="element circle-1"></div>
        <div class="element circle-2"></div>
        <div class="element square-1"></div>
        <div class="element square-2"></div>
        <div class="element triangle-1"></div>
      </div>
    </section>

    <!-- Sección de Características -->
    <section class="features">
      <div class="feature-card">
        <div class="feature-icon">
          <i class="bi bi-eye"></i>
        </div>
        <h3>Accesibilidad</h3>
        <p>Contraste óptimo para una experiencia visual cómoda en cualquier condición de luz</p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">
          <i class="bi bi-battery-charging"></i>
        </div>
        <h3>Eficiencia</h3>
        <p>Modo oscuro para reducir el consumo energético en dispositivos con pantalla OLED</p>
      </div>

      <div class="feature-card">
        <div class="feature-icon">
          <i class="bi bi-heart"></i>
        </div>
        <h3>Confort</h3>
        <p>Reduce la fatiga visual durante sesiones prolongadas de trabajo nocturno</p>
      </div>
    </section>

    <!-- Paleta de Colores - TARJETAS FIJAS -->
    <section class="color-palette">
      <h2>Paleta de Colores</h2>
      <p class="palette-description">Colores cuidadosamente seleccionados para cada modo</p>

      <div class="palette-grid">
        <!-- Modo Claro -->
        <div class="palette-mode">
          <h3>Blue Mist Light</h3>
          <div class="color-items">
            <!-- TARJETAS CON COLORES FIJOS - NO CAMBIAN CON EL TEMA -->
            <div class="color-item tarjeta-fondo-claro tarjeta-dce3ea">
              <span class="color-name">Fondo Principal</span>
              <span class="color-hex">#DCE3EA</span>
              <span class="color-role">Fondo general</span>
            </div>
            <div class="color-item tarjeta-fondo-claro tarjeta-f2f5f9">
              <span class="color-name">Superficies</span>
              <span class="color-hex">#F2F5F9</span>
              <span class="color-role">Tarjetas y paneles</span>
            </div>
            <div class="color-item tarjeta-fondo-oscuro tarjeta-141a23">
              <span class="color-name">Texto Principal</span>
              <span class="color-hex">#141A23</span>
              <span class="color-role">Texto y encabezados</span>
            </div>
            <div class="color-item tarjeta-fondo-oscuro tarjeta-5c8df6">
              <span class="color-name">Acento Primario</span>
              <span class="color-hex">#5C8DF6</span>
              <span class="color-role">Botones y enlaces</span>
            </div>
            <div class="color-item tarjeta-fondo-claro tarjeta-758499">
              <span class="color-name">Texto Secundario</span>
              <span class="color-hex">#758499</span>
              <span class="color-role">Texto menos importante</span>
            </div>
            <div class="color-item tarjeta-fondo-oscuro tarjeta-89afff">
              <span class="color-name">Estados Hover</span>
              <span class="color-hex">#89AFFF</span>
              <span class="color-role">Interacciones</span>
            </div>
          </div>
        </div>

        <!-- Modo Oscuro -->
        <div class="palette-mode">
          <h3>Blue Mist Dark</h3>
          <div class="color-items">
            <!-- TARJETAS CON COLORES FIJOS - NO CAMBIAN CON EL TEMA -->
            <div class="color-item tarjeta-fondo-oscuro tarjeta-0f1420">
              <span class="color-name">Fondo Principal</span>
              <span class="color-hex">#0F1420</span>
              <span class="color-role">Fondo general</span>
            </div>
            <div class="color-item tarjeta-fondo-oscuro tarjeta-1a2235">
              <span class="color-name">Superficies</span>
              <span class="color-hex">#1A2235</span>
              <span class="color-role">Tarjetas y paneles</span>
            </div>
            <div class="color-item tarjeta-fondo-claro tarjeta-e8edf5">
              <span class="color-name">Texto Principal</span>
              <span class="color-hex">#E8EDF5</span>
              <span class="color-role">Texto y encabezados</span>
            </div>
            <div class="color-item tarjeta-fondo-oscuro tarjeta-5c8df6-2">
              <span class="color-name">Acento Primario</span>
              <span class="color-hex">#5C8DF6</span>
              <span class="color-role">Botones y enlaces</span>
            </div>
            <div class="color-item tarjeta-fondo-claro tarjeta-8a9bb0">
              <span class="color-name">Texto Secundario</span>
              <span class="color-hex">#8A9BB0</span>
              <span class="color-role">Texto menos importante</span>
            </div>
            <div class="color-item tarjeta-fondo-oscuro tarjeta-6366f1">
              <span class="color-name">Estados Hover</span>
              <span class="color-hex">#6366F1</span>
              <span class="color-role">Interacciones</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'

export default {
  name: 'DModoClaroOscuro',
  setup () {
    const route = useRoute()
    return {
      demoId: route.params.demoId
    }
  },
  data() {
    return {
      isLightMode: false
    }
  },
  mounted () {
    console.log('🎮 Demo montado:', this.demoId);

    const savedTheme = localStorage.getItem('theme-mode');
    if (savedTheme === 'light') {
      this.isLightMode = true;
    }

    window.dispatchEvent(new CustomEvent('activate-demo-mode', {
      detail: { projectId: this.demoId || 'modo-claro-oscuro' }
    }));
  },
  beforeUnmount () {
    console.log('🎮 Demo desmontado');
    window.dispatchEvent(new CustomEvent('deactivate-demo-mode'));
  },
  methods: {
    toggleTheme() {
      localStorage.setItem('theme-mode', this.isLightMode ? 'light' : 'dark');
    }
  }
}
</script>

<style scoped>
/* PANTALLA AL 100% */
.demo-container {
  min-height: 100vh;
  background: var(--color-background, #0F1420);
  color: var(--color-text-primary, #E8EDF5);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0;
  padding: 0;
  width: 100%;
  overflow-x: hidden;
}

/* Variables para modo claro (Blue Mist Light) */
.demo-container.light-mode {
  --color-background: #c9d8f8;
  --color-surface: #F2F5F9;
  --color-primary: #1458a0;
  --color-accent: #89AFFF;
  --color-text-primary: #141A23;
  --color-text-secondary: #758499;
  --color-navbar: #89afff;
  --color-border: rgba(117, 132, 153, 0.3);
}

/* Navbar */
.demo-navbar {
  background: var(--color-navbar, rgba(26, 34, 53, 0.95));
  backdrop-filter: blur(10px);
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--color-border, rgba(255, 255, 255, 0.1));
  position: sticky;
  top: 0;
  z-index: 100;
  width: 100%;
  box-sizing: border-box;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 700;
  font-size: 1.2rem;
  color: var(--color-primary);
}

.nav-links {
  display: flex;
  gap: 2rem;
}

.nav-link {
  color: var(--color-text-primary);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
  padding: 0.5rem 1rem;
  border-radius: 8px;
}

.nav-link:hover {
  color: var(--color-primary);
  background: rgba(92, 141, 246, 0.1);
}

/* Hero Section */
.hero {
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 2rem;
  width: 100%;
  box-sizing: border-box;
}

.hero-content {
  text-align: center;
  max-width: 600px;
  z-index: 2;
  position: relative;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: var(--color-text-primary);
}

.hero p {
  font-size: 1.3rem;
  color: var(--color-text-secondary);
  margin-bottom: 2rem;
  line-height: 1.6;
}

/* Toggle Interruptor Deslizante */
.theme-toggle-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin: 2.5rem 0;
}

.toggle-label {
  color: var(--color-text-primary);
  font-weight: 600;
  font-size: 0.9rem;
}

.switch {
  position: relative;
  display: inline-block;
  width: 80px;
  height: 40px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 32px;
  width: 32px;
  left: 4px;
  bottom: 4px;
  background: white;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 50%;
  z-index: 2;
}

input:checked + .slider {
  background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
}

input:checked + .slider:before {
  transform: translateX(40px);
}

.moon-icon, .sun-icon {
  font-size: 0.8rem;
  z-index: 1;
  transition: all 0.4s ease;
}

.moon-icon {
  color: white;
}

.sun-icon {
  color: #ff6b6b;
}

/* Botones de Acción */
.hero-actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
}

.btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.btn-primary {
  background: var(--color-primary);
  color: white;
  border: 1px solid var(--color-primary);
}

.btn-primary:hover {
  background: var(--color-accent);
  border-color: var(--color-accent);
  transform: translateY(-1px);
}

.btn-secondary {
  background: transparent;
  color: var(--color-text-primary);
  border: 1px solid var(--color-text-secondary);
}

.btn-secondary:hover {
  background: rgba(92, 141, 246, 0.1);
  border-color: var(--color-primary);
  transform: translateY(-1px);
}

/* ELEMENTOS DECORATIVOS */
.hero-elements {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.element {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  animation: float 8s ease-in-out infinite;
  transition: all 0.4s ease;
  filter: blur(1px);
}

/* Círculos con gradientes azules */
.circle-1 {
  width: 200px;
  height: 200px;
  top: 10%;
  left: 10%;
  background: linear-gradient(135deg, #5C8DF6 0%, #89AFFF 50%, #6366F1 100%);
  animation-delay: 0s;
}

.circle-2 {
  width: 150px;
  height: 150px;
  bottom: 20%;
  right: 15%;
  background: linear-gradient(135deg, #6366F1 0%, #5C8DF6 50%, #89AFFF 100%);
  animation-delay: 2s;
}

/* Cuadrados con gradientes */
.square-1 {
  width: 100px;
  height: 100px;
  top: 60%;
  left: 5%;
  border-radius: 25px;
  animation-delay: 1s;
  background: linear-gradient(135deg, #5C8DF6 0%, #89AFFF 100%);
  opacity: 0.12;
}

.square-2 {
  width: 120px;
  height: 120px;
  top: 20%;
  right: 5%;
  border-radius: 30px;
  animation-delay: 3s;
  background: linear-gradient(135deg, #6366F1 0%, #5C8DF6 100%);
  opacity: 0.12;
}

/* Triángulo con gradiente */
.triangle-1 {
  width: 0;
  height: 0;
  top: 70%;
  right: 20%;
  border-left: 60px solid transparent;
  border-right: 60px solid transparent;
  border-bottom: 100px solid;
  border-bottom-color: #5C8DF6;
  background: transparent !important;
  opacity: 0.1;
  animation-delay: 1.5s;
  filter: none;
}

/* MODO OSCURO: Cambiar formas a colores oscuros */
.demo-container:not(.light-mode) .circle-1 {
  background: linear-gradient(135deg, #1A2235 0%, #0F1420 50%, #6366F1 100%);
}

.demo-container:not(.light-mode) .circle-2 {
  background: linear-gradient(135deg, #6366F1 0%, #1A2235 50%, #0F1420 100%);
}

.demo-container:not(.light-mode) .square-1 {
  background: linear-gradient(135deg, #1A2235 0%, #0F1420 100%);
}

.demo-container:not(.light-mode) .square-2 {
  background: linear-gradient(135deg, #6366F1 0%, #1A2235 100%);
}

.demo-container:not(.light-mode) .triangle-1 {
  border-bottom-color: #1A2235;
}

/* Ajustes de opacidad para modo claro */
.demo-container.light-mode .element {
  opacity: 0.08;
  filter: blur(0.5px);
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg) scale(1);
  }
  50% {
    transform: translateY(-20px) rotate(180deg) scale(1.05);
  }
}

/* Features Section */
.features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.feature-card {
  background: var(--color-surface, #1A2235);
  padding: 2.5rem 2rem;
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid var(--color-border, rgba(255, 255, 255, 0.1));
}

.feature-card:hover {
  transform: translateY(-5px);
  border-color: var(--color-primary);
}

.feature-icon {
  font-size: 2.5rem;
  color: var(--color-primary);
  margin-bottom: 1.5rem;
}

.feature-card h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: var(--color-text-primary);
}

.feature-card p {
  color: var(--color-text-secondary);
  line-height: 1.6;
}

/* PALETA DE COLORES - TARJETAS FIJAS */
.color-palette {
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.color-palette h2 {
  text-align: center;
  color: var(--color-text-primary);
  margin-bottom: 0.5rem;
  font-size: 2.2rem;
}

.palette-description {
  text-align: center;
  color: var(--color-text-secondary);
  margin-bottom: 3rem;
  font-size: 1.1rem;
}

.palette-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
}

.palette-mode h3 {
  color: var(--color-text-primary);
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 1.4rem;
}

.color-items {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

/* ESTILOS PARA LAS 12 TARJETAS FIJAS - NO CAMBIAN CON EL TEMA */
.color-item {
  padding: 1.5rem 1rem;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border: 1px solid rgba(117, 132, 153, 0.3);
  transition: transform 0.2s ease;
  min-height: 100px;
}

.color-item:hover {
  transform: scale(1.02);
}

.color-name {
  font-weight: 600;
  font-size: 0.9rem;
}

.color-hex {
  font-family: 'Courier New', monospace;
  font-size: 0.8rem;
  opacity: 0.8;
}

.color-role {
  font-size: 0.75rem;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* CLASES ESPECÍFICAS PARA CADA COLOR - FONDOS FIJOS */
/* Fondos claros - texto negro */
.tarjeta-fondo-claro {
  color: #000000 !important;
}

.tarjeta-fondo-oscuro {
  color: #FFFFFF !important;
}

/* Colores específicos - CADA UNO CON SU COLOR FIJO */
.tarjeta-dce3ea { background-color: #DCE3EA !important; }
.tarjeta-f2f5f9 { background-color: #F2F5F9 !important; }
.tarjeta-141a23 { background-color: #141A23 !important; }
.tarjeta-5c8df6 { background-color: #5C8DF6 !important; }
.tarjeta-758499 { background-color: #758499 !important; }
.tarjeta-89afff { background-color: #89AFFF !important; }
.tarjeta-0f1420 { background-color: #0F1420 !important; }
.tarjeta-1a2235 { background-color: #1A2235 !important; }
.tarjeta-e8edf5 { background-color: #E8EDF5 !important; }
.tarjeta-5c8df6-2 { background-color: #5C8DF6 !important; }
.tarjeta-8a9bb0 { background-color: #8A9BB0 !important; }
.tarjeta-6366f1 { background-color: #6366F1 !important; }

/* Responsive */
@media (max-width: 768px) {
  .hero h1 {
    font-size: 2.2rem;
  }

  .hero p {
    font-size: 1.1rem;
  }

  .demo-navbar {
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
  }

  .nav-links {
    gap: 1rem;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
  }

  .features {
    grid-template-columns: 1fr;
    padding: 2rem 1rem;
  }

  .palette-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .color-items {
    grid-template-columns: 1fr;
  }

  .theme-toggle-section {
    flex-direction: column;
    gap: 0.5rem;
  }

  /* Ajustar elementos decorativos en móvil */
  .element {
    display: none;
  }

  .circle-1, .circle-2 {
    display: block;
    width: 100px;
    height: 100px;
  }
}
</style>
